import Vue from 'vue'
import { generateShortId } from '@/utils/crypto.js'

/**
 * @todo Refactor/Remove if unused
 */
Vue.use({
  install(Vue) {
    Vue.directive(
      'esc',
      (() => {
        const keydowns = {}
        var binded = false
        return {
          bind(el, binding) {
            bindLoop()

            function bindLoop(start = Date.now()) {
              if (Date.now() - start > 2000) {
                throw new Error('v-esc: bind timeout')
              }
              if (binded) {
                return setTimeout(bindLoop, 50)
              }
              el.dataset.v_esc_id = generateShortId()
              keydowns[el.dataset.v_esc_id] = function keydown(event) {
                if (event.which === 27) {
                  if (typeof binding.value === 'function') {
                    binding.value(event)
                  }
                }
              }
            }

            document.addEventListener('keydown', keydowns[el.dataset.v_esc_id])
          },
          unbind(el) {
            document.removeEventListener(
              'keydown',
              keydowns[el.dataset.v_esc_id]
            )
            binded = false
          },
        }
      })()
    )
  },
})
